import { render, staticRenderFns } from "./LanguageInput.vue?vue&type=template&id=36a03714&"
import script from "./LanguageInput.vue?vue&type=script&lang=js&"
export * from "./LanguageInput.vue?vue&type=script&lang=js&"
import style0 from "./LanguageInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports